import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetSubscriptionIdQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
}>;


export type GetSubscriptionIdQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, subscription: { __typename?: 'AccountSubscription', id: string } } | null };


export const GetSubscriptionId = /*#__PURE__*/ gql`
    query GetSubscriptionId($accountId: ID!) {
  account(accountId: $accountId) {
    id
    subscription {
      id
    }
  }
}
    ` as unknown as DocumentNode<GetSubscriptionIdQuery, GetSubscriptionIdQueryVariables>;

          

          export const useGetSubscriptionIdQuery = (options?:QueryHookOptions<GetSubscriptionIdQuery, GetSubscriptionIdQueryVariables>) => useQuery(GetSubscriptionId, options);

          

          export type GetSubscriptionIdQueryOptions = QueryHookOptions<GetSubscriptionIdQuery, GetSubscriptionIdQueryVariables>;

          

          export const useGetSubscriptionIdLazyQuery = (options?:LazyQueryHookOptions<GetSubscriptionIdQuery, GetSubscriptionIdQueryVariables>) => useLazyQuery(GetSubscriptionId, options);

          

          export type GetSubscriptionIdQueryResult = ReturnType<typeof useGetSubscriptionIdQuery>;

          
